import { createSlice } from "@reduxjs/toolkit";
import { AppDesign } from "../../types/configurationType";
import { fetchAppDesignThunk, updateAppDesignColorThunk, updateAppDesignLogoThunk } from "../thunk/configurationThunk";

export interface ConfigInterface {
    appDesign: AppDesign
}

const initialState: ConfigInterface = {
    appDesign: {
        companyLogo: null,
        accentColor: null
    }
};

export const configurationReducer = createSlice({
    name: "configuration",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(
            fetchAppDesignThunk.fulfilled,
            (state, action) => {
                state.appDesign = action.payload ?? state.appDesign;
            }
        );
        builder.addCase(
            updateAppDesignColorThunk.fulfilled,
            (state, action) => {
                state.appDesign = { ...state.appDesign, ...(action.payload ?? {}) };
            }
        );
        builder.addCase(
            updateAppDesignLogoThunk.fulfilled,
            (state, action) => {
                state.appDesign = { ...state.appDesign, ...(action.payload ?? {}) };
            }
        );
    }
})

export default configurationReducer.reducer;